<template>
    <div class="team-member-box position-relative">
        <div class="team-member-image position-relative">
            <img :src="member.image" :alt="member.name">
            <ul class="social position-absolute d-flex align-center justify-content-center transition-3s">
                <li><a href="#"><font-awesome-icon :icon="['fab', 'facebook-f']" /></a></li>
                <li><a href="#"><font-awesome-icon :icon="['fab', 'twitter']" /></a></li>
                <li><a href="#"><font-awesome-icon :icon="['fab', 'google-plus-g']" /></a></li>
                <li><a href="#"><font-awesome-icon :icon="['fab', 'pinterest-p']" /></a></li>
            </ul>
        </div>
        <div class="team-member-name-designation position-absolute transition-3s">
            <h3>{{member.name}}</h3>
            <p>{{member.designation}}</p>
        </div>
    </div>
</template>

<script>
export default {
    name: 'TeamMember',
    props: ['member']
}
</script>